import Service from "../../service";

const FormService = {
  // Form Api's
  getFormList: async (
    token,
    current_page,
    items_per_page,
    orgId,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `/schools/v1/online-form/list?current_page=${current_page}&items_per_page=${items_per_page}&orgId=${orgId}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  getOnlineFormsById: async (token, id) => {
    try {
      return await Service.get(`/schools/v1/online-form?id=${id}`, token);
    } catch (error) {
      throw error;
    }
  },
  getFormById: async (token, id, orgId) => {
    try {
      return await Service.get(
        `schools/v1/form?id=${id}&orgId=${orgId}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },
  deleteOnlineForm: async (token, id) => {
    try {
      return await Service.remove({
        url: `/schools/v1/online-form?id=${id}`,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  getEventParticipants: async (
    token,
    current_page,
    items_per_page,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `/schools/v1/event/participant/list?current_page=${current_page}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  getEventParticipantById: async (token, id) => {
    try {
      return await Service.get(`/schools/v1/event/participant?id=${id}`, token);
    } catch (error) {
      throw error;
    }
  },
  updateEventParticipant: async (token, body, id) => {
    try {
      return await Service.update({
        url: `/schools/v1/event/participant?id=${id}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  deleteEventParticipantById: async (token, id) => {
    try {
      return await Service.remove({
        url: `/schools/v1/event/participant?id=${id}`,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  exportParticipant: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/event/participant/export`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  createOnlineFormParticipant: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/online-form/participant`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  calculateSchoolPrice: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/participant/calculate-price`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  calculateSchoolPriceBulk: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/participant/calculate-price-bulk`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  reserveSeats: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/online-form/participant/reserve`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  calculateFormPrice: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/online-form/participant/calculate-price`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  deleteTicket: async (token, body) => {
    try {
      return await Service.remove({
        url: `/schools/v1/online-form/participant/reserve`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  sentCode: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/membership-form/send-code`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  verifyCode: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/membership-form/verify-code`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  submitMembership: async (token, body) => {
    try {
      return await Service.post({
        url: `/schools/v1/membership-form/participant/submit-form`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
};
export default FormService;
